import { render } from "./RowLoading.vue?vue&type=template&id=6bf3832c"
const script = {}
script.render = render

export default script